<template>
  <header id="header">
    <div class="h1_area">
      <h1></h1>
    </div>
    <div class="header_area">
      <div class="header_left">
        <p>
          <router-link :to="{ name: 'home' }">
            <img
              src="@/assets/img/common/h_logo_online.png"
              alt="天下一品ロゴ"
              class="pc1060"
              width="403"
              height="55"
            />
            <img
              src="@/assets/img/common/h_logo_online_sp.png"
              alt="天下一品ロゴ"
              class="sp1060"
              width="403"
              height="55"
            />
          </router-link>
        </p>
      </div>
      <div :class="{ 'overlay-open': isMenuOpen }" class="header_right">
        <ul class="header_btn_area">
          <template v-if="!isAuthenticated">
            <li v-for="item in Nav" :key="item.name" :class="item.class">
              <router-link
                :id="item.id"
                class="nav-link"
                active-class="active"
                exact
                :to="{ name: item.route }"
              >
                {{ item.name }}
                <span class="cart_icon" v-if="item.route === 'cart'">
                  <span v-if="cartLength" class="cart_number">{{
                    cartLength
                  }}</span>
                </span>
              </router-link>
            </li>
          </template>
          <template v-if="isAuthenticated">
            <li v-for="item in NavAuth" :key="item.name" :class="item.class">
              <router-link
                :id="item.id"
                class="nav-link"
                active-class="active"
                exact
                :to="{ name: item.route }"
              >
                {{ item.name }}
                <span class="cart_icon" v-if="item.route === 'cart'">
                  <span v-if="cartLength" class="cart_number">{{
                    cartLength
                  }}</span>
                </span>
              </router-link>
            </li>
          </template>
        </ul>
        <nav class="navigation_area">
          <div :class="{ open: isMenuOpen }" class="sp_option overlay-hugeinc">
            <ul class="menu">
              <li v-for="item in categories" :key="item.name">
                <router-link :to="item.route">
                  <span class="menu_txt">{{ item.name }}</span>
                </router-link>
              </li>
              <li class="pc1060">
                <router-link :to="{ name: 'cart' }">
                  <span class="cart_icon">
                    <span v-if="cartLength" class="cart_number">{{
                      cartLength
                    }}</span>
                    <span class="menu_txt">
                      <span class="hidden_txt"> カート </span>
                    </span>
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <div class="sp_navList">
        <p
          @click="setIsOpen(!isMenuOpen)"
          :class="{ active: isMenuOpen }"
          id="trigger-overlay"
        >
          <span></span>
        </p>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import JwtService from "@/common/jwt.service";

export default {
  name: "RwvHeader",
  data: function () {
    return {
      Nav: [
        {
          route: "emailValidation",
          name: "新規会員登録",
          id: "new_member",
          class: "header_btn_style01"
        },
        {
          route: "login",
          name: "ログイン",
          id: "login",
          class: "header_btn_style01"
        },
        {
          route: "guide",
          name: "お買い物ガイド",
          id: "guide",
          class: "header_btn_style01"
        },
        {
          route: "cart",
          name: "カート",
          id: "cart01",
          class: "header_btn_style01 sp1060"
        }
      ],
      NavAuth: [
        {
          route: "profile",
          name: "マイページ",
          id: "new_member",
          class: "header_btn_style01"
        },
        {
          route: "logout",
          name: "ログアウト",
          id: "logout",
          class: "header_btn_style01"
        },
        {
          route: "guide",
          name: "お買い物ガイド",
          id: "guide",
          class: "header_btn_style01"
        },
        {
          route: "cart",
          name: "カート",
          id: "cart01",
          class: "header_btn_style01 sp1060"
        }
      ],
      categories: [
        // {
        //   route: {
        //     name: "goodsList",
        //     query: { tagName: "おすすめ商品" }
        //   },
        //   name: "おすすめ商品"
        // },
        {
          route: {
            name: "noodlesDetail",
            params: { id: process.env.VUE_APP_CATEGORY_THICK }
          },
          name: "こってり"
        },
        // {
        //   route: { name: "noodlesDetail", params: { id: 24 } },
        //   name: "あっさり"
        // },
        {
          route: {
            name: "noodlesDetail",
            params: { id: process.env.VUE_APP_CATEGORY_MIX }
          },
          name: "ミックス"
        },
        {
          route: {
            name: "goodsList",
            query: { categoryName: "オリジナル商品" }
          },
          name: "オリジナル商品"
        },
        {
          route: {
            name: "goodsList",
            query: { categoryName: "天下一品コラボ商品" }
          },
          name: "天下一品\nコラボ商品"
        },
        {
          route: {
            name: "goodsList",
            query: { categoryName: "オリジナルどんぶり" }
          },
          name: "オリジナル\nどんぶり"
        },
        {
          route: {
            name: "goodsList",
            query: { categoryName: "グッズ" }
          },
          name: "グッズ"
        }
      ],
      isMenuOpen: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated", "cart", "cartLocal"]),
    cartProducts() {
      if (this.isAuthenticated) {
        return (this.cart && this.cart[0] && this.cart[0].products) || [];
      } else {
        const localStorageCart = JwtService.getCartLocal();
        return (
          this.cartLocal || (localStorageCart && JSON.parse(localStorageCart))
        );
      }
    },
    cartLength() {
      return this.cartProducts && this.cartProducts.length;
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "home" }));
    },
    setIsOpen(value) {
      this.isMenuOpen = value;
    }
  },
  watch: {
    $route() {
      this.isMenuOpen = false;
    }
  }
};
</script>

<style scoped>
.menu_txt {
  white-space: pre;
}
@media screen and (max-width: 1060px) {
  .header_btn_style01 a#cart01 {
    position: relative;
  }
  .header_btn_style01 a#cart01 .cart_icon {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
  }
}
</style>
